import { render } from "./boardPicker.vue?vue&type=template&id=322bdd5e&scoped=true"
import script from "./boardPicker.vue?vue&type=script&lang=js"
export * from "./boardPicker.vue?vue&type=script&lang=js"

import "./boardPicker.vue?vue&type=style&index=0&id=322bdd5e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-322bdd5e"]])

export default __exports__